<template>
  <div v-if="loading" class="mt-[8px]">
    <v-progress-circular class="mr-3" indeterminate size="20" width="2" color="primary" />
    <b :class="labelClass || 'theme--light v-label text-base text-end'">{{ label }}</b>
  </div>
  <v-checkbox
    v-else-if="!readonly"
    class="cfs-field cfs-checkbox"
    :color="color"
    dense
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
  >
    <template #label>
      <template v-if="$hasSlot('label')">
        <slot name="label" />
      </template>
      <b v-else-if="label" :class="labelClass">{{ label }}</b>
    </template>
  </v-checkbox>
  <CfsReadonlyField v-else :label="label" :value="inputValue ? $t('Yes') : $t('No')" />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

export default defineComponent({
  components: {
    CfsReadonlyField: defineAsyncComponent(
      () => import('@/framework/inputs/special/CfsReadonlyFieldComponent.vue')
    ),
  },
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    inputValue: {
      type: [Boolean, Array] as PropType<boolean | unknown[]>,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: [Boolean, String],
      default: true,
    },
    falseValue: {
      type: [Boolean, String],
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.cfs-checkbox {
  width: fit-content;
  &.disable-label {
    :deep(.v-input__control) {
      .v-input__slot {
        .v-label {
          pointer-events: none;
        }
      }
    }
  }
  :deep(.v-input__control) {
    width: fit-content;
    flex-grow: 0;
    .v-input__slot {
      width: fit-content;
      padding: 0 !important;
    }
    .v-messages {
      @apply text-blue-havelock;
    }
  }
}
</style>
